<template>
  <FeesTable
    :rows="rows"
    :loading="loading"
    :empty-text="emptyText"
    :pagination="pagination"
    :show-business-column="showBusinessColumn"
    :show-provider-column="showProviderColumn"
    :split-payment-and-status-columns="true"
    @page-change="$emit('page-change', $event)"
    @pay-expense="$emit('pay-expense', $event)"
    @delete-expense="$emit('delete-expense', $event)"
    @edit-expense="$emit('edit-expense', $event)"
    @approve-expense="$emit('approve-expense', $event)"
    @download-xml="$emit('download-xml', $event)"
    @download-pdf="$emit('download-pdf', $event)"
    @download-receipt="$emit('download-receipt', $event)"
  />
</template>

<script>
import FeesTable from '@/components/fees/FeesTable.vue';

export default {
  name: 'SaleSharedFeesTable',
  components: {
    FeesTable,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: 'Sin gastos disponibles para los filtros seleccionados.',
    },
    pagination: {
      type: Object,
      default: () => ({
        current_page: 1,
        per_page: 30,
        total_pages: 1,
        total_items: 0,
      }),
    },
    showProviderColumn: {
      type: Boolean,
      default: true,
    },
    showBusinessColumn: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'page-change',
    'pay-expense',
    'delete-expense',
    'edit-expense',
    'approve-expense',
    'download-xml',
    'download-pdf',
    'download-receipt',
  ],
};
</script>
